import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Renderer2,
  ElementRef,
  TemplateRef,
  ViewContainerRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  AfterViewInit,
} from '@angular/core';
import { FormArray, UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { merge, fromEvent, Observable, Subject } from 'rxjs';
import { MatLegacyMenu as MatMenu } from '@angular/material/legacy-menu';
import { debounceTime, map, switchMap, takeUntil } from 'rxjs/operators';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { Project } from 'app/modules/projects/projects.types';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ProjectMarkAcquiredComponent } from 'app/modules/projects/modals/project-mark-acquired/project-mark-acquired.component';
import { ProjectChangeTemplateComponent } from 'app/modules/projects/modals/project-change-template/project-change-template.component';
import { ProjectShowDealEmailComponent } from 'app/modules/projects/modals/project-show-deal-email/project-show-deal-email.component';
import { AccountService } from 'app/core';
import { Account, Activity } from 'app/core/models/account.types';
import { SharedResourcesService } from 'app/modules/shared-resources/shared-resources.service';
import { SharedResource } from 'app/modules/shared-resources/shared-resources.types';

@Component({
  selector: 'shared-resource-project-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SharedResourcesProjectHeaderComponent implements OnInit {
  project: Project;
  private _unsubscribeAll: Subject<void>;
  // Mat menu
  @ViewChild('matMenu', { static: true })
  matMenu: MatMenu;

  data: any;
  account: Account;

  projects$: Observable<Project[]>;
  projectList: number[];
  currentProjectIndex: number;
  prev: number;
  next: number;
  sharedResource: SharedResource;

  /**
   * Constructor
   *
   * @param {ProjectsService} _projectsService
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private _sharedResourcesService: SharedResourcesService,
    private _router: Router,
    private _matDialog: MatDialog,
    private _formBuilder: UntypedFormBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
    private _activatedRoute: ActivatedRoute,
    private _accountService: AccountService,
  ) {
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this._sharedResourcesService.sharedResource$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((sharedResource: SharedResource) => {
        if (sharedResource) {
          this.sharedResource = sharedResource;
          this.project = this.sharedResource.project;
        }
      });
  }
}
